import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const apiKeyInterceptor: HttpInterceptorFn = (request, next) => {
  const isApiUrl = request.url.startsWith(environment.API_URL);

  if (isApiUrl) {
    request = request.clone({
      setHeaders: {
        'Api-Key': environment.API_KEY,
      },
    });
  }

  return next(request);
};
